module.exports = {"id":"169426","name":"Barragán","rating":"74","photo":"./data/images/photos/4/169426.png","club":{"name":"Real Betis","logo":"./data/images/clubs/RealBetis.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Barragan0.json
// module id = 532
// module chunks = 0